import { render } from "./Article.vue?vue&type=template&id=3ebb3ed5&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=3ebb3ed5&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebb3ed5"]])

export default __exports__